/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { productsJsmOrganizationListResource } from '@jira/router-resources__organizations-list/src/productsJsmOrganizationListResource.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmOrganizationsRoute } from '@jira/router-routes__products-jsm-organizations-routes/src/productsJsmOrganizationsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ProductsJsmOrganizations, {
	LazyProductsJsmOrganizations,
} from './ui/admin-pages/products-jsm-organizations/index.tsx';

export const productsJsmOrganizationsRouteEntry: Route = createEntry(
	productsJsmOrganizationsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-organization-page-list',
		isRedirect: false,
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJsmOrganizations,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			productsJsmOrganizationListResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProductsJsmOrganizations],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
